import React from "react";

import arrow from "../../images/arrow.png";
import Tipster from "../partials/tipster";
import Faq from "../partials/faq";
import Footer from "../partials/footer";
import Usernav from "../partials/usernav";
import { useRecoilValue } from "recoil";
import { selectAuthUser } from "../../atom";
import Nav from "../partials/nav";
import { useLocation } from "react-router-dom";
import img1 from "../../images/svgs/3722BF30-1DD0-4E7B-A76E-72ED2B78BB74-removebg-preview 10.svg";
import img2 from "../../images/svgs/3722BF30-1DD0-4E7B-A76E-72ED2B78BB74-removebg-preview 7.svg";
import img3 from "../../images/svgs/3722BF30-1DD0-4E7B-A76E-72ED2B78BB74-removebg-preview 8.svg";
import img4 from "../../images/svgs/3722BF30-1DD0-4E7B-A76E-72ED2B78BB74-removebg-preview 9.svg";
import img5 from "../../images/svgs/40DFCB17-2A95-4377-86A1-DB016E4E30BC-removebg-preview 2.svg";
import img6 from "../../images/svgs/40DFCB17-2A95-4377-86A1-DB016E4E30BC-removebg-preview 3.svg";
import img7 from "../../images/svgs/40DFCB17-2A95-4377-86A1-DB016E4E30BC-removebg-preview 4.svg";
import img8 from "../../images/svgs/40DFCB17-2A95-4377-86A1-DB016E4E30BC-removebg-preview 5.svg";

const Mybets = () => {
  const user = useRecoilValue(selectAuthUser);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const params = Object.fromEntries(searchParams.entries());

  return (
    <div>
      {/* <Usernav /> */}
      <Nav isPublic={params?.username && params?.externalId} />

      <div className="container">
        {params?.username && params?.externalId ? (
          <div className="flex flex-wrap lg:flex-nowrap justify-between items-center gap-6">
            <img src={img1} />
            <img src={img2} />
            <img src={img3} />
            <img src={img4} />
            <img src={img5} />
            <img src={img6} />
            <img src={img7} />
            <img src={img8} />
          </div>
        ) : (
          <div className="row">
            <div className="col-lg-12">
              <h3 className="main-header">
                <span>My </span>Bet codes
              </h3>
              <p className="hero-intro">
                Hello {user?.username}, keep it up you're awesome for helping
                others win. 🎉💥💯
              </p>{" "}
              <img src={arrow} className="img-fluid arrow" alt="arrow" />
            </div>
          </div>
        )}
      </div>

      <Tipster isPublic={params?.username && params?.externalId}></Tipster>
      <Faq></Faq>
      <Footer></Footer>
    </div>
  );
};

export default Mybets;
